import type React from "react";
import { useAdminContractCreatProps } from "./fetch";
import { AdminContractCreatePageUi } from "./ui/";

export const AdminContractCreatePage: React.FC<{
  deliveryProposalOfferCargoIdStr: string | undefined;
}> = (params) => {
  const props = useAdminContractCreatProps(
    params.deliveryProposalOfferCargoIdStr,
  );
  return <AdminContractCreatePageUi {...props} />;
};
